<template>
  <div>
    <vs-card>
      <form role="form" @submit.stop.prevent="buscar">
        <div :class="`vx-row mb-6`">
          <div :class="`vx-col sm:w-36 mt-3 w-full`">
            <span>Placa</span>
            <vs-input
              ref="placa"
              class="w-full"
              name="Placa"
              id="Placa"
              v-mask="'AAA-#XX#'"
              v-model="formFiltro.placa"
              @keyup.enter="buscar"
              @focus="updateLastFocused('placa')"
            />
          </div>

          <div class="vx-col sm:w-52 w-full mt-3">
            <span>CPF/CNPJ</span>
            <vs-input
              class="w-full"
              ref="cpfCnpj"
              name="Cpf Cnpj"
              id="Cpf Cnpj"
              v-model="formFiltro.cpfCnpj"
              v-mask="`${cpfCnpjMask}`"
              @keyup.enter="buscar"
              @focus="updateLastFocused('cpfCnpj')"
            />
          </div>

          <div class="vx-col sm:w-40 w-full mt-3">
            <span>Cód. Beneficiário</span>
            <vs-input
              class="w-full"
              ref="codigo"
              name="codigo"
              id="codigo"
              v-model="formFiltro.idProspect"
              @keyup.enter="buscar"
              @focus="updateLastFocused('codigo')"
            />
          </div>

          <div class="vx-col sm:w-48 w-full mt-3">
            <span>Contato</span>
            <vs-input
              class="w-full"
              name="Contato"
              id="Contato"
              ref="Contato"
              v-mask="`${telefoneMask}`"
              v-model="formFiltro.contato"
              @keyup.enter="buscar"
              @focus="updateLastFocused('Contato')"
            />
          </div>

          <div :class="`vx-col sm:w-60 mt-3 w-full`">
            <span>Chassi</span>
            <vs-input
              class="w-full"
              name="Chassi"
              id="Chassi"
              ref="Chassi"
              v-model="formFiltro.chassi"
              @keyup.enter="buscar"
              v-mask="'XXXXXXXXXXX######'"
              @focus="updateLastFocused('Chassi')"
            />
          </div>

          <div class="vx-col sm:w-88 w-full mt-3">
            <span>Email</span>
            <vs-input
              class="w-full"
              name="Email"
              id="Email"
              ref="Email"
              v-model="formFiltro.email"
              @keyup.enter="buscar"
              @focus="updateLastFocused('Email')"
            />
          </div>

          <div class="vx-col sm:w-88 w-full mt-3">
            <span>Nome</span>
            <AutoComplete
              customClass="w-full"
              name="Nome"
              id="Nome"
              ref="Nome"
              v-model="formFiltro.nomeAssociado"
              :configAutoComplete="{ model: 'Associados', field: 'nome' }"
              @keyup.enter="buscar"
              @focus="updateLastFocused('Nome')"
            />
          </div>
        </div>
      </form>

      <div slot="footer" style="margin-top: -3%">
        <br style="clear: both" />
        <vs-row class="flex justify-end">
          <vs-button
            color="success"
            type="filled"
            icon-pack="feather"
            icon="icon-search"
            class="mr-3 mb-2"
            @click="buscar"
            >Buscar</vs-button
          >
          <vs-button
            v-if="b2c == false"
            @click="limparFiltro"
            color="danger"
            type="gradient"
            icon-pack="feather"
            icon="icon-trash-2"
          ></vs-button>
        </vs-row>
      </div>
    </vs-card>
  </div>
</template>

<script>
import * as lang from 'vuejs-datepicker/src/locale';
import service from '../../services';
import jwt from 'jsonwebtoken';
import AutoComplete from '../../components/autocomplete/AutoComplete.vue';

export default {
  props: {
    sideBar: {
      type: Boolean,
    },
    dados: {
      type: Object,
    },
    vistoria: {
      type: Boolean,
    },
    b2c: {
      type: Boolean,
    },
  },

  computed: {
    telefoneMask() {
      const ehCelular =
        this.formFiltro.contato && this.formFiltro.contato.length > 14;
      if (ehCelular) {
        return '(##) #####-####';
      }
      return '(##) ####-####';
    },
    cpfCnpjMask() {
      const ehCnpj =
        this.formFiltro.cpfCnpj && this.formFiltro.cpfCnpj.length > 14;
      if (ehCnpj) {
        return '##.###.###/####-##';
      }
      return '###.###.###-##';
    },
  },
  data() {
    return {
      aguardeCadastro: false,
      idEmpresa: null,
      estados: [],
      regionalDefault: [],
      regionaisUsuario: [],
      cidades: [],
      grupos: [],
      regionais: [],
      usuarios_regionais: [],
      consultores: [],
      status: [],
      languages: lang,
      filtroAvancado: false,
      tiposProposta: [
        'Adesão',
        'Reativação',
        'Substituição',
        'Inclusão',
        'Troca de Titularidade',
        'Migração',
      ],
      tiposDatas: ['Data Cadastro', 'Data Vistoria'],
      listaSimNao: ['Sim', 'Não'],
      estado: null,
      funcoesValicao: null,
      formFiltro: {
        idEmpresa: null,
        cpfCnpj: '',
        nomeAssociado: null,
        consultor: null,
        regional: null,
        status: null,
        idGrupo: null,
        cidade: '',
        estado: '',
        idProspect: null,
        tipoCotacao: null,
        diaVencimento: null,
        placa: null,
        chassi: null,
        email: null,
        contato: null,
      },
      refInput: null,
    };
  },
  methods: {
    limparFiltro() {
      this.formFiltro = {
        cpfCnpj: null,
        nomeAssociado: null,
        consultor: null,
        regional: null,
        status: null,
        idGrupo: null,
        cidade: '',
        estado: '',
        idProspect: null,
        tipoCotacao: null,
        diaVencimento: null,
        placa: null,
        chassi: null,
        email: null,
        contato: null,
      };
      this.$emit('clear');
      this.focusInput(this.refInput);
    },
    getDecoded() {
      const token = localStorage.getItem('user-token');
      if (token) {
        this.decoded = jwt.decode(token);
      }
      this.id_usuario = this.decoded.id_usuario;
    },
    dataInicio() {
      const a = new Date();
      const b = a.setDate(a.getDate() - 1);
      return b;
    },

    async buscaDadosFiltros() {
      try {
        this.$vs.loading();

        await service
          .post('cotacao', 'busca-filtros-consultores-regionais', this.decoded)
          .then(({ data }) => {
            data.consultores.forEach((element) => {
              this.consultores.push({
                id: element.id_usuario,
                label: element.nome,
              });
            });

            data.regionais.forEach((element) => {
              this.regionais.push({
                id: element.idRegional,
                label: element.nome,
              });
            });
          });
      } catch (error) {
        this.$vs.notify({
          position: 'top-center',
          title: 'Falha ao buscar filtros',
          text: error,
          color: 'danger',
        });
      } finally {
        this.$vs.loading.close();
      }
    },
    buscar() {
      const temFiltro = Object.values(this.formFiltro).some((value) => value);
      if (!temFiltro) {
        this.limparFiltro();
        this.$vs.notify({
          position: 'top-center',
          title: 'Atenção',
          text: 'É necessário preencher pelo menos um campo para o filtro!',
          color: 'warning',
        });
        return;
      }
      this.$emit('filtro', this.formFiltro);
      this.focusInput(this.refInput);
    },
    updateLastFocused(refInput) {
      this.refInput = refInput;
    },
    focusInput(refInput = 'placa') {
      const inputElement = this.$refs[refInput].$el.querySelector('input');
      if (inputElement) {
        inputElement.focus();
      }
    },
  },
  mounted() {
    this.getDecoded();
    this.$nextTick(() => {
      this.focusInput();
    });
  },
  components: {
    AutoComplete,
  },
};
</script>

<style>
.vs__dropdown-toggle {
  padding: 4px 0 6px 0 !important;
}

.vdp-datepicker input {
  width: 100%;
}

.vdp-datepicker__calendar {
  z-index: 900 !important;
}
</style>
